import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PopularCategoriesContainer from 'src/containers/PopularCategoriesContainer';
import PopularCitiesContainer from 'src/containers/PopularCitiesContainer';
import PopularSearchesContainer from 'src/containers/PopularSearchesContainer';


const SeoBoxContainer = ({ hasCities, hasCategories, hasSearches }) => {
  if (hasCategories) {
    return (
      <PopularCategoriesContainer />
    );
  }
  if (hasCities) {
    return (
      <PopularCitiesContainer />
    );
  }
  if (hasSearches) {
    return (
      <PopularSearchesContainer />
    );
  }

  return null;
};

SeoBoxContainer.propTypes = {
  hasCategories: PropTypes.bool.isRequired,
  hasCities: PropTypes.bool.isRequired,
  hasSearches: PropTypes.bool.isRequired
};

const mapStateToProperties = ({ seoReducer }) => ({
  hasCities: Boolean(seoReducer.cities.length),
  hasCategories: Boolean(seoReducer.categories.length),
  hasSearches: Boolean(seoReducer.searches.length)
});

export default connect(mapStateToProperties)(SeoBoxContainer);
